import React, { Component } from "react";
import { Link } from "react-router-dom";
import HelperClass from "../../../config/helperClass";
import { THEME_COLOR, THEME_TEXT_COLOR } from "../../../config/config";
import {
  getLead, updateStage,
  listStages,   listLeadsGrid,
} from "./api/leads_api";
import { FALLBACK_STAGES, PRIORITIES, LEAD_SOURCES } from "./api/leads_constants";

const auth = new HelperClass();

const EMPTY_FORM = {
  company: "", contact_name: "", email: "", phone: "",
  job_title: "", industry: "", website: "", address: "",
  deal_value: "", priority: "med", stage_key: "new",
  source: "", score: 50, next_action_date: "",
  partner_accountno: "", partner_contact: "",
  notes: "", products: [],
};

export default class LeadEdit extends Component {
  state = {
    mobileMenuOpen: false,
    loading: true,
    saving: false,
    lead: null,            // original loaded lead
    originalStage: "",     // to detect stage changes
    form: { ...EMPTY_FORM },
    stages: [],
    partners: [],
    partnerProducts: [],
    partnersLoading: true,
    error: "",
    saveError: "",
    saved: false,
  };

  get lead_uid() {
    return (
      this.props &&
      this.props.props &&
      this.props.props.match &&
      this.props.props.match.params &&
      this.props.props.match.params.lead_uid
    ) || null;
  }

  componentDidMount() {
    this.load();
    this._onResize = () => { if (window.innerWidth >= 576) this.setState({ mobileMenuOpen: false }); };
    window.addEventListener("resize", this._onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._onResize);
  }

  componentDidUpdate(prevProps) {
    const prev =
      prevProps && prevProps.props && prevProps.props.match &&
      prevProps.props.match.params && prevProps.props.match.params.lead_uid;
    if (prev !== this.lead_uid) this.load();
  }

  load = async () => {
    this.setState({ loading: true, error: "", saveError: "", saved: false });
    const uid = this.lead_uid;
    if (!uid) { this.setState({ loading: false, error: "Missing lead id." }); return; }

    try {
      // parallel: resolve uid, load stages, load partners
      const [searchRes, stagesRes, partnersRes] = await Promise.all([
        listLeadsGrid(auth.getAccount(), auth.getToken(), { search: uid, page: 1, page_size: 5 }),
        listStages(auth.getAccount(), auth.getToken()),
      ]);

      // stages
      const stagesRaw = stagesRes && stagesRes.data && stagesRes.data.status === 200
        ? stagesRes.data.data || []
        : FALLBACK_STAGES;
      const stages = stagesRaw.filter(function(s) { return s.active !== 0; });

      // partners
      const partners = partnersRes && partnersRes.data && partnersRes.data.status === 200
        ? partnersRes.data.data || []
        : [];

      // resolve uid → id
      const rows = searchRes && searchRes.data && searchRes.data.data && searchRes.data.data.rows;
      const row = (rows || []).find(function(r) { return r.lead_uid === uid; });
      if (!row) {
        this.setState({ loading: false, stages, partners, partnersLoading: false, error: "Lead not found." });
        return;
      }

      // full lead data
      const r = await getLead(auth.getAccount(), auth.getToken(), row.id);
      if (!r || !r.data || r.data.status !== 200) {
        this.setState({ loading: false, stages, partners, partnersLoading: false, error: "Failed to load lead." });
        return;
      }
      const d = r.data.data;
      const lead = d.lead;

      // build pre-populated form
      const form = {
        company:          lead.company         || "",
        contact_name:     lead.contact_name    || "",
        email:            lead.email           || "",
        phone:            lead.phone           || "",
        job_title:        lead.job_title       || "",
        industry:         lead.industry        || "",
        website:          lead.website         || "",
        address:          lead.address         || "",
        deal_value:       lead.deal_value != null ? String(lead.deal_value) : "",
        priority:         lead.priority        || "med",
        stage_key:        lead.stage_key       || "new",
        source:           lead.source          || "",
        score:            lead.score != null ? lead.score : 50,
        next_action_date: lead.next_action_date
          ? String(lead.next_action_date).slice(0, 10)
          : "",
        partner_accountno: lead.partner_accountno || "",
        partner_contact:   lead.partner_contact   || "",
        notes:             lead.notes            || "",
        products:          (d.products || []).map(function(p) {
          return { service_id: p.service_id, service_title: p.service_title };
        }),
      };

      this.setState({
        loading: false, lead, originalStage: lead.stage_key || "new",
        form, stages, partners, partnersLoading: false,
      });

      // load partner products if a partner is already set
      if (lead.partner_accountno) {
        this.loadPartnerProducts(lead.partner_accountno);
      }
    } catch (ex) {
      this.setState({ loading: false, error: "Network error loading lead." });
    }
  };

  // loadPartnerProducts = async (partner_accountno) => {
  //   if (!partner_accountno) { this.setState({ partnerProducts: [] }); return; }
  //   try {
  //     const r = await listPartnerProducts(auth.getAccount(), auth.getToken(), partner_accountno);
  //     const prods = r && r.data && r.data.status === 200 ? r.data.data || [] : [];
  //     this.setState({ partnerProducts: prods });
  //   } catch (_) {
  //     this.setState({ partnerProducts: [] });
  //   }
  // };

  patch = (field, value) => {
    this.setState(function(s) { return { form: Object.assign({}, s.form, { [field]: value }) }; });
  };

  // onPartnerChange = (partner_accountno) => {
  //   this.patch("partner_accountno", partner_accountno);
  //   this.patch("products", []);
  //   this.setState({ partnerProducts: [] });
  //   if (partner_accountno) this.loadPartnerProducts(partner_accountno);
  // };

  toggleProduct = (svc) => {
    this.setState(function(s) {
      const cur = s.form.products || [];
      const exists = cur.some(function(p) { return p.service_id === svc.service_id; });
      const products = exists
        ? cur.filter(function(p) { return p.service_id !== svc.service_id; })
        : cur.concat([{ service_id: svc.service_id, service_title: svc.service_title }]);
      return { form: Object.assign({}, s.form, { products: products }) };
    });
  };

  // save = async () => {
  //   const { form, lead, originalStage } = this.state;
  //   if (!form.company.trim()) { this.setState({ saveError: "Company name is required." }); return; }

  //   this.setState({ saving: true, saveError: "" });
  //   try {
  //     // 1. update editable fields + products
  //     const payload = {
  //       lead_id: lead.id,
  //       company:           form.company.trim(),
  //       contact_name:      form.contact_name || "",
  //       email:             form.email || "",
  //       phone:             form.phone || "",
  //       job_title:         form.job_title || "",
  //       industry:          form.industry || "",
  //       website:           form.website || "",
  //       address:           form.address || "",
  //       deal_value:        form.deal_value !== "" ? form.deal_value : 0,
  //       priority:          form.priority,
  //       source:            form.source || "",
  //       score:             form.score,
  //       next_action_date:  form.next_action_date || "",
  //       partner_accountno: form.partner_accountno || "",
  //       partner_contact:   form.partner_contact || "",
  //       notes:             form.notes || "",
  //       products:          JSON.stringify(form.products || []),
  //     };
  //     const r = await updateLead(auth.getAccount(), auth.getToken(), payload);
  //     if (!r || !r.data || r.data.status !== 200) {
  //       const msg = r && r.data && r.data.message ? r.data.message : "Failed to save changes.";
  //       this.setState({ saving: false, saveError: msg });
  //       return;
  //     }

  //     // 2. stage change (separate endpoint)
  //     if (form.stage_key !== originalStage) {
  //       const sr = await updateStage(auth.getAccount(), auth.getToken(), {
  //         lead_id: lead.id,
  //         stage_key: form.stage_key,
  //       });
  //       if (!sr || !sr.data || sr.data.status !== 200) {
  //         // fields already saved, just warn about stage
  //         this.setState({ saving: false, saveError: "Lead saved but stage update failed." });
  //         return;
  //       }
  //     }

  //     this.setState({ saving: false, saved: true, originalStage: form.stage_key });
  //   } catch (ex) {
  //     this.setState({ saving: false, saveError: "Network error. Please try again." });
  //   }
  // };

  render() {
    const {
      loading, saving, saved, lead, form, stages, partners,
      partnerProducts, partnersLoading, error, saveError,
    } = this.state;
    const uid = this.lead_uid;

    return (
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">

              {/* ── header ── */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      {lead ? `Edit — ${lead.company}` : "Edit Lead"}
                    </h3>
                    <div className="nk-block-des text-soft">
                      <p>{uid || ""}</p>
                    </div>
                  </div>
                  <div className="nk-block-head-content" style={{ position: "relative" }}>
                    <button className="btn btn-sm d-sm-none" style={{ border: "none", outline: "none", background: "transparent", boxShadow: "none" }} onClick={() => this.setState({ mobileMenuOpen: !this.state.mobileMenuOpen })}>
                      <em className="icon ni ni-more-v"></em>
                    </button>
                    <div className={`d-none d-sm-flex align-items-center${this.state.mobileMenuOpen ? " d-flex" : ""}`} style={this.state.mobileMenuOpen ? { position: "absolute", top: "calc(100% + 6px)", right: 0, flexDirection: "column", background: "#fff", border: "1px solid #dbdfea", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.1)", zIndex: 100, minWidth: 170, padding: "6px 0", gap: 0 } : { gap: 8 }}>
                      <Link to={uid ? `/crm_lead_detail/${uid}` : "/crm_leads"} className="btn btn-outline-light btn-sm" style={this.state.mobileMenuOpen ? { border: "none", borderRadius: 0, width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start", padding: "8px 16px" } : {}}>
                        <em className="icon ni ni-arrow-left" style={{ marginRight: 4 }}></em> <span>Back</span>
                      </Link>
                      <Link to="/crm_leads" className="btn btn-outline-light btn-sm" style={this.state.mobileMenuOpen ? { border: "none", borderRadius: 0, width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start", padding: "8px 16px" } : {}}>All Leads</Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── loading ── */}
              {loading && (
                <div style={{ textAlign: "center", padding: "60px 0" }}>
                  <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                  <span style={{ marginLeft: 10, color: "#888" }}>Loading lead…</span>
                </div>
              )}

              {/* ── error ── */}
              {!loading && error && (
                <div className="alert alert-danger">
                  {error}{" "}
                  <button className="btn btn-sm btn-danger" onClick={this.load}>Retry</button>
                </div>
              )}

              {/* ── success banner ── */}
              {saved && (
                <div className="alert alert-success" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span><em className="icon ni ni-check-circle me-1"></em> Changes saved successfully.</span>
                  <Link to={`/crm_lead_detail/${uid}`} className="btn btn-sm btn-success">View Lead</Link>
                </div>
              )}

              {/* ── form ── */}
              {!loading && lead && (
                <div className="row g-gs">
                  {/* left column — main form */}
                  <div className="col-lg-8">

                    {/* ── Contact Info ── */}
                    <div className="card card-bordered mb-3">
                      <div className="card-inner">
                        <h6 className="title" style={{ marginBottom: 16, borderBottom: "1px solid #f0f0f0", paddingBottom: 10 }}>
                          <em className="icon ni ni-user me-1" style={{ color: "#1c5bde" }}></em> Contact Info
                        </h6>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <label className="form-label">Company <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" value={form.company}
                              onChange={function(e) { this.patch("company", e.target.value); }.bind(this)}
                              placeholder="Company name" />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Contact Name</label>
                            <input type="text" className="form-control" value={form.contact_name}
                              onChange={function(e) { this.patch("contact_name", e.target.value); }.bind(this)}
                              placeholder="Full name" />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Email</label>
                            <input type="email" className="form-control" value={form.email}
                              onChange={function(e) { this.patch("email", e.target.value); }.bind(this)}
                              placeholder="email@example.com" />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Phone</label>
                            <input type="text" className="form-control" value={form.phone}
                              onChange={function(e) { this.patch("phone", e.target.value); }.bind(this)}
                              placeholder="+1 555 000 0000" />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Job Title</label>
                            <input type="text" className="form-control" value={form.job_title}
                              onChange={function(e) { this.patch("job_title", e.target.value); }.bind(this)} />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Industry</label>
                            <input type="text" className="form-control" value={form.industry}
                              onChange={function(e) { this.patch("industry", e.target.value); }.bind(this)} />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Website</label>
                            <input type="text" className="form-control" value={form.website}
                              onChange={function(e) { this.patch("website", e.target.value); }.bind(this)}
                              placeholder="https://" />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Address</label>
                            <input type="text" className="form-control" value={form.address}
                              onChange={function(e) { this.patch("address", e.target.value); }.bind(this)} />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ── Partner ── */}
                    <div className="card card-bordered mb-3">
                      <div className="card-inner">
                        <h6 className="title" style={{ marginBottom: 16, borderBottom: "1px solid #f0f0f0", paddingBottom: 10 }}>
                          <em className="icon ni ni-users me-1" style={{ color: "#6b3fa0" }}></em> Partner
                        </h6>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <label className="form-label">Assign Partner</label>
                            <select className="form-control" value={form.partner_accountno}
                              onChange={function(e) { this.onPartnerChange(e.target.value); }.bind(this)}
                              disabled={partnersLoading}>
                              <option value="">{partnersLoading ? "Loading partners…" : "-- No Partner --"}</option>
                              {partners.map(function(p) {
                                return (
                                  <option key={p.accountno} value={p.accountno}>
                                    {p.comp_name || p.name} ({p.email})
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Partner Contact</label>
                            <input type="text" className="form-control" value={form.partner_contact}
                              onChange={function(e) { this.patch("partner_contact", e.target.value); }.bind(this)}
                              placeholder="Contact name at partner" />
                          </div>
                          {partnerProducts.length > 0 && (
                            <div className="col-12">
                              <label className="form-label">Interested Products</label>
                              <div style={{ maxHeight: 140, overflowY: "auto", border: "1px solid #e5e9f2", borderRadius: 4, padding: "8px 12px" }}>
                                {partnerProducts.map(function(svc) {
                                  const checked = (form.products || []).some(function(p) { return p.service_id === svc.service_id; });
                                  return (
                                    <div key={svc.service_id} className="custom-control custom-checkbox">
                                      <input type="checkbox" className="custom-control-input"
                                        id={"edit_prod_" + svc.service_id} checked={checked}
                                        onChange={function() { this.toggleProduct(svc); }.bind(this)} />
                                      <label className="custom-control-label" htmlFor={"edit_prod_" + svc.service_id}>
                                        {svc.service_title}
                                      </label>
                                    </div>
                                  );
                                }.bind(this))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* ── Notes ── */}
                    <div className="card card-bordered mb-3">
                      <div className="card-inner">
                        <h6 className="title" style={{ marginBottom: 16, borderBottom: "1px solid #f0f0f0", paddingBottom: 10 }}>
                          <em className="icon ni ni-notes me-1" style={{ color: "#d97706" }}></em> Notes
                        </h6>
                        <textarea className="form-control" rows={4} value={form.notes}
                          onChange={function(e) { this.patch("notes", e.target.value); }.bind(this)}
                          placeholder="Notes or context about this lead…" />
                      </div>
                    </div>

                  </div>

                  {/* right column — deal details + actions */}
                  <div className="col-lg-4">

                    {/* ── Save card ── */}
                    <div className="card card-bordered mb-3" style={{ borderTop: "3px solid " + THEME_COLOR }}>
                      <div className="card-inner">
                        {saveError && <div className="alert alert-danger mb-3" style={{ fontSize: 13 }}>{saveError}</div>}
                        <button
                          type="button"
                          className="btn w-100"
                          style={{ background: THEME_COLOR, color: THEME_TEXT_COLOR }}
                          disabled={saving || !form.company.trim()}
                          onClick={this.save}
                        >
                          {saving
                            ? <span><div className="spinner-border spinner-border-sm me-1" style={{ width: 14, height: 14 }}></div> Saving…</span>
                            : <span><em className="icon ni ni-save me-1"></em> Save Changes</span>
                          }
                        </button>
                        <div style={{ marginTop: 8 }}>
                          <Link to={uid ? `/crm_lead_detail/${uid}` : "/crm_leads"}
                            className="btn btn-outline-light w-100">
                            Cancel
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* ── Deal Details ── */}
                    <div className="card card-bordered mb-3">
                      <div className="card-inner">
                        <h6 className="title" style={{ marginBottom: 16, borderBottom: "1px solid #f0f0f0", paddingBottom: 10 }}>
                          <em className="icon ni ni-bar-chart me-1" style={{ color: "#1a7a4a" }}></em> Deal Details
                        </h6>
                        <div className="row g-3">
                          <div className="col-12">
                            <label className="form-label">Stage</label>
                            <select className="form-control" value={form.stage_key}
                              onChange={function(e) { this.patch("stage_key", e.target.value); }.bind(this)}>
                              {stages.map(function(s) {
                                return <option key={s.stage_key} value={s.stage_key}>{s.label}</option>;
                              })}
                            </select>
                            {form.stage_key !== this.state.originalStage && (
                              <div style={{ fontSize: 11, color: "#d97706", marginTop: 4 }}>
                                Stage will be updated on save.
                              </div>
                            )}
                          </div>
                          <div className="col-12">
                            <label className="form-label">Priority</label>
                            <select className="form-control" value={form.priority}
                              onChange={function(e) { this.patch("priority", e.target.value); }.bind(this)}>
                              {PRIORITIES.map(function(p) {
                                return <option key={p.value} value={p.value}>{p.label}</option>;
                              })}
                            </select>
                          </div>
                          <div className="col-12">
                            <label className="form-label">Deal Value ($)</label>
                            <input type="number" className="form-control" value={form.deal_value} min="0"
                              onChange={function(e) { this.patch("deal_value", e.target.value); }.bind(this)} />
                          </div>
                          <div className="col-12">
                            <label className="form-label">Source</label>
                            <select className="form-control" value={form.source}
                              onChange={function(e) { this.patch("source", e.target.value); }.bind(this)}>
                              <option value="">-- Select Source --</option>
                              {LEAD_SOURCES.map(function(s) { return <option key={s} value={s}>{s}</option>; })}
                            </select>
                          </div>
                          <div className="col-12">
                            <label className="form-label">Next Action Date</label>
                            <input type="date" className="form-control" value={form.next_action_date}
                              onChange={function(e) { this.patch("next_action_date", e.target.value); }.bind(this)} />
                          </div>
                          <div className="col-12">
                            <label className="form-label">
                              Score <span style={{ fontSize: 11, color: "#888" }}>(0 – 100)</span>
                            </label>
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                              <input
                                type="range" min="0" max="100"
                                value={form.score}
                                onChange={function(e) { this.patch("score", Number(e.target.value)); }.bind(this)}
                                style={{ flex: 1 }}
                              />
                              <span style={{
                                minWidth: 36, textAlign: "center", fontWeight: 700, fontSize: 14,
                                color: form.score >= 70 ? "#1a7a4a" : form.score >= 40 ? "#d97706" : "#b02a2a",
                              }}>{form.score}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ── Lead Info (read-only) ── */}
                    <div className="card card-bordered">
                      <div className="card-inner">
                        <h6 className="title" style={{ marginBottom: 10, fontSize: 12, color: "#9a9690", textTransform: "uppercase", letterSpacing: "0.05em" }}>Lead Info</h6>
                        <div style={{ fontSize: 12, color: "#6b7280", lineHeight: 2 }}>
                          <div><strong>UID:</strong> {lead.lead_uid}</div>
                          <div><strong>Created:</strong> {lead.created_at ? new Date(lead.created_at).toLocaleDateString() : "—"}</div>
                          <div><strong>Updated:</strong> {lead.updated_at ? new Date(lead.updated_at).toLocaleDateString() : "—"}</div>
                          {lead.won_at && <div><strong>Won:</strong> {new Date(lead.won_at).toLocaleDateString()}</div>}
                          {lead.lost_at && <div><strong>Lost:</strong> {new Date(lead.lost_at).toLocaleDateString()}</div>}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

